<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-技术培训报名-添加
    -->
  <el-dialog
    title="添加技术培训报名"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">添加技术培训报名</div>
        <!-- 全分类选择 -->
        <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为技术培训报名标题</el-button>
      </el-form-item> -->

        <el-form-item label="选择技术培训项目" prop="technical_training_id">
          <el-select
            v-model="form.technical_training_id"
            filterable
            placeholder="请选择技术培训项目"
            style="width: 100%"
            :loading="loadingTechnicalTrainings"
          >
            <el-option
              v-for="technicalTraining in technicalTrainingList"
              :key="technicalTraining.technical_training_id"
              :label="technicalTraining.name"
              :value="technicalTraining.technical_training_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 类型选择 -->
        <el-form-item label="报名类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio label="junior">初级</el-radio>
            <el-radio label="intermediate">中级</el-radio>
            <el-radio label="senior">高级</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="form.type === 'junior'">
          <el-form-item label="姓名" prop="name"
            ><el-input
              v-model="form.name"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="电话" prop="phone"
            ><el-input
              v-model="form.phone"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="身份证" prop="identity_card"
            ><el-input
              v-model="form.identity_card"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>
        </template>

        <template
          v-else-if="form.type === 'intermediate' || form.type === 'senior'"
        >
          <el-form-item label="姓名" prop="name"
            ><el-input
              v-model="form.name"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="电话" prop="phone"
            ><el-input
              v-model="form.phone"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="身份证" prop="identity_card"
            ><el-input
              v-model="form.identity_card"
              placeholder="请输入身份证"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="驾驶证：" prop="model.image">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="form.image">
                <transition-group>
                  <div
                    v-for="(item, index) in form.image"
                    :key="item.file_path"
                  >
                    <div class="item">
                      <img v-img-url="item.file_path" alt="file_path" />
                      <a
                        href="javascript:void(0);"
                        class="delete-btn"
                        @click.stop="deleteImg(index, 'album')"
                        ><i class="el-icon-close"></i
                      ></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('album')">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>
        </template>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Technical_training_signApi from "@/api/technical_training_sign.js";
import Technical_trainingApi from "@/api/technical_training.js";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      technicalTrainingList: [],
      loadingTechnicalTrainings: false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: "",
        gender: 0,
        phone: "",
        identity_card: "",
        type: "junior",
        code: "custom",
        image: [],
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          // { required: true, message: "请输入技术培训报名名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.addtechnicalTrainingList();
  },
  props: ["open_add"],
  methods: {
    addtechnicalTrainingList() {
      var self = this;
      Technical_trainingApi.listx({}, true)
        .then(data => {
          self.loading = false;
          self.technicalTrainingList = data.data;
        })
        .catch(error => {});
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      // if (form.image.length <= 0) {
      //   self.$message({
      //     message: "请上传图片",
      //     type: "error"
      //   });
      //   return;
      // }

      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Technical_training_signApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/technical_training_sign/index/part/add.vue